import React from 'react';
import { FormattedMessage } from 'react-intl';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import ManualPayoutList from '../../../data/types/siteadmin/ManualPayoutList/ManualPayoutList';
import Loader from '../../../components/Common/Loader';

import messages from '../../../locale/messages';
import getAllOrdersAdmin from './getAllOrdersAdmin.graphql';
import s from '../../site-admin/adminEarnings/AdminEarnings.css';
class Restaurant extends React.Component {

  static defaultProps = {
    bookingDetails: {
      loading: true
    }
  };

  render() {
    const { bookingDetails, bookingDetails: { loading } } = this.props;
    return (
      <Loader type={"page"} show={loading}>
        <div className={s.root}>
          <div className={s.container}>
            <div className={s.heading}>
              <FormattedMessage {...messages.managePayout} />
            </div>
             <div className={s.paddingRoutesSection}>
             {!loading && <ManualPayoutList bookingDetails={bookingDetails} requestType="completed" />}
             </div>
          </div>
        </div>
      </Loader>
    );
  }
}

export default compose(
  withStyles(s),
  graphql(getAllOrdersAdmin, {
    name: 'bookingDetails',
    options: {
      ssr: true,
      fetchPolicy: 'network-only',
      variables: {
        currentPage: 1,
        searchList: '',
        requestType: 'completed',
        payoutFilter: ''
      }
    }
  })
)(Restaurant);
